import React, {useState} from 'react'

import { Navigate } from 'react-router-dom'
import { Button } from 'react-bootstrap'

import PowerBoardList from './PowerBoardList.js'

import '../../BigButton.css'

export default function PowerBoardInventory(props)
{
    const [onRedirectToCreate, setOnRedirectToCreate] = useState(false);

    const onCreateNewPowerBoard = (event) =>
    {
        setOnRedirectToCreate(true);

        event.preventDefault();
    };

    if(onRedirectToCreate)
    {
        return ( <Navigate to="/inventory_management/power_board/create/"/>);
    }
    else
    {
        return (
            <div>
            <p>{"\n\n"}</p>
            <PowerBoardList />
            <p>{"\n\n"}</p>
            <Button
                variant="primary"
                className="BigButton"
                onClick={onCreateNewPowerBoard}>
                    Create New Power Board
            </Button>
            <p>{"\n\n"}</p>
            </div>
        );
    }
}
